import type { HttpClient } from '@shared/http/http-client';
import type {
  ILabRouteRepository,
  LabRouteListQuery,
} from '@domain/data-contracts/lab-route-repository.interface';
import type { LabRoute } from '@domain/models/lab-route.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import {
  mapLabRouteDto,
  mapPaged,
  type LabRouteDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/routes';

export class LabRouteRepository implements ILabRouteRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: LabRouteListQuery): Promise<PagedResult<LabRoute>> {
    const response = await this.http.get<PagedDto<LabRouteDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapLabRouteDto);
  }
}

function pruneParams(query: LabRouteListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
